import React from 'react';
import { Link, useParams } from 'react-router-dom';

function UpdatePowerBreadCrumb() {
  const {plantName} = useParams();
        // Convert slug (with -) back to spaces
        const decodedPlantName = plantName.replace(/-/g, ' ');
  return (
    <div className="breadcrumb-wrapper py-3 px-3">
      <div className="container">
        <h2 className="breadcrumb-title mb-2">{decodedPlantName}</h2>
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb custom-breadcrumb mb-0">
            <li className="breadcrumb-item">
              <Link to="/Admin" className="breadcrumb-link">Dashboard</Link>
            </li>
            <li className="breadcrumb-item">
              <Link to="/powergeneration" className="breadcrumb-link">Power Generation Plants in India</Link>
            </li>
            <li className="breadcrumb-item active" aria-current="page">
              {plantName}
            </li>
          </ol>
        </nav>
      </div>
    </div>
  );
}
export default UpdatePowerBreadCrumb;
